module.exports = __webpack_public_path__ + "static/media/cerrar-sesion-icon.07f1d65b.png";